// extracted by mini-css-extract-plugin
module.exports = {"map":"map_map__2t_zr","logo":"map_logo__2DP42","location":"map_location__2Z38D","approve":"map_approve__1zdE-"};